import { useState, useEffect } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";
import { Cast, Loader2, Tv, Speaker, Smartphone, Check } from "lucide-react";

const FAKE_DEVICES = [
  { id: "tv1", name: "Salon TV", type: "tv", icon: Tv },
  { id: "spk1", name: "Cuisine HomePod", type: "speaker", icon: Speaker },
  { id: "ph1", name: "iPad Chambre", type: "tablet", icon: Smartphone },
];

export default function CastPage() {
  const [scanning, setScanning] = useState(true);
  const [devices, setDevices] = useState([]);
  const [casting, setCasting] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      setDevices(FAKE_DEVICES);
      setScanning(false);
    }, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-6 py-12" data-testid="cast-page">
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight flex items-center gap-3 mb-2">
          <Cast size={28} /> Caster
        </h1>
        <p className="text-sm text-gray-500 mb-8">Diffusez OmniSearch sur un appareil compatible.</p>

        {scanning && (
          <div className="border border-dashed border-[var(--omni-border)] rounded-lg p-10 text-center">
            <Loader2 className="animate-spin inline mb-3 text-[var(--omni-accent)]" />
            <p className="text-gray-500">Recherche d'appareils…</p>
          </div>
        )}

        {!scanning && (
          <ul className="space-y-3">
            {devices.map((d) => {
              const Icon = d.icon;
              const active = casting === d.id;
              return (
                <li key={d.id}>
                  <button
                    onClick={() => setCasting(active ? null : d.id)}
                    data-testid={`cast-device-${d.id}`}
                    className={`w-full flex items-center gap-4 p-4 rounded-lg border transition text-left ${active ? "border-[var(--omni-accent)] bg-orange-50" : "border-[var(--omni-border)] hover:border-black"}`}
                  >
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${active ? "bg-[var(--omni-accent)] text-white" : "bg-[var(--omni-surface)]"}`}>
                      <Icon size={18} />
                    </div>
                    <div className="flex-1">
                      <div className="font-medium">{d.name}</div>
                      <div className="text-xs text-gray-500">{d.type}</div>
                    </div>
                    {active && <Check className="text-[var(--omni-accent)]" size={20} />}
                  </button>
                </li>
              );
            })}
          </ul>
        )}

        {casting && (
          <div className="mt-6 p-4 rounded-lg bg-[var(--omni-surface)] border border-[var(--omni-border)]">
            <p className="text-sm">Diffusion en cours vers <strong>{devices.find((d) => d.id === casting)?.name}</strong>.</p>
            <Button onClick={() => setCasting(null)} variant="outline" size="sm" className="mt-3 rounded-full" data-testid="stop-casting-btn">Arrêter</Button>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
